import { IPhoto } from "models/api";
import { IPaginatedData } from "models/common";
import { IStat } from "shared/models/Performers/SearchStats";

export enum MembershipTypes {
  performer = "Performer",
  graduate = "Graduate",
  youngPerformer = "YoungPerformer",
  presenter = "Presenter",
  dancer = "Dancer",
}

export interface IAgent {
  id: string;
  name: string;
}

export interface IPerformer {
  suggestedTime: string;
  artistRef: string;
  comments: string;
  surname: string;
  forename: string;
  artistType: string;
  publicationCode: number;
  isInactive: boolean;
  mainPhoto: string;
  profileHref: string;
  runningOrder: number;
  agency: IAgent;
  expiryDate?: string;
  youngPerformerAge?: string;
  id: string;
  roleName: string;
  email: string;
  videoShowreelHref: string;
  voiceClipsHref: string;
}

export interface IMakeSuggestionsDropDownChecboxFilterTranslation {
  filterLabel: string;
  searchPlaceholder: string;
  noResults: string;
}

export interface IMakeSuggestionsSuggestion {
  id?: string;
  photo: string;
  comment: string;
}

export interface IAvailability {
  externalId: number;
  externalParentId?: number;
  projectId: string;
  profileId: string;
  startDateUtc: string;
  endDateUtc?: string;
  title: string;
  type: string;
  category: string;
  notes?: string;
  colour: string;
  toBeConfirmed: boolean;
  allDay: boolean;
  visible: boolean;
  agencyId: number;
  externalAgencyId: number;
  availability?: IAvailability[];
}

export interface IAvailabilityRecord extends IAvailability {
  availability: IAvailability[];
}

export type IAvailabilityCalendar = IAvailabilityRecord[];

export interface IMakeSuggestionsPerformer {
  genders?: number[];
  appearances?: number[];
  artistRef: string;
  forenames: string;
  surname: string;
  mainPhoto: IPhoto;
  gallery: IPhoto[];
  performerType: string;
  hasAudioClip: boolean;
  hasVideoClip: boolean;
  dateOfBirth: string;
  hasNudge: boolean;
  hasSelfSuggestion: boolean;
  agency: IAgent;
  _links: {
    profile: {
      href: string;
    };
  };
  suggestion?: IMakeSuggestionsSuggestion;
  expiryDate?: string;
  tagminAvailability: [];
}

export type SuggestionID = string;

export interface ISuggestion {
  id: SuggestionID;
  photo: {
    fileName: string;
  };
  performer: {
    artistRef: string;
    forenames: string;
    surname: string;
  };
  dateCreated: Date;
  agency: {
    id: number;
  };
  amendmentCount: number;
  _links: {
    profile: {
      href: string;
    };
  };
  comment?: string;
  suggestedBy: string;
}

export interface INudge {
  id: string;
  agency: string;
  dateCreated: string;
}

export interface IMakeSuggestionsPerformersResponse {
  items: IMakeSuggestionsPerformer[];
  total: number;
  _links: {};
}

export interface IMakeSuggestionsPerformersStatsResponse {
  appearances: Array<IStat<number>>;
  heritageAndEthnicity: Array<IStat<number>>;
}

export interface IMakeSuggestionsCard extends IPerformer {}

export interface IPaginatedCardList
  extends IPaginatedData<IMakeSuggestionsCard> {}

export interface IPaginatedPerformersCardList
  extends IPaginatedData<IMakeSuggestionsPerformer> {}
